var render = function render(){var _vm=this,_c=_vm._self._c;return _c('polygon',{attrs:{"points":"15 9 12 0 9 9 0 9 7.216 14.488 4.25 23.618 12 17.987 19.75 23.618 16.784 14.488 24 9 15 9"}})
}
var staticRenderFns = []

export { render, staticRenderFns }